import Cookies from 'js-cookie';

export default (homeUrl) => ({
  response: null,
  init() {
    this.$refs.dialogAgeGateKeeper.showModal();

    this.$watch('response', (value) => {
      Cookies.set('ageGateKeeper', value);

      if (value == 1) {
        setTimeout(() => {
          this.$refs.dialogAgeGateKeeper.close();
        }, 101);
      }
    });
  }
});
